import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { summaryExeDateData, summaryExeDateDel } from "@/api/updateConfiguration/updateConfiguration";
import addpackagename from "./components/addpackagename";
export default {
  name: "updateConfiguration",
  components: {
    addpackagename: addpackagename
  },
  data: function data() {
    return {
      tableData: [],
      addpackagename: false,
      total: 0,
      page: 1,
      showing: false,
      sels: [],
      selsString: '',
      searchData: {
        page: 1,
        page_size: 10
      },
      isLoading: false
    };
  },
  created: function created() {
    this.getData(1);
  },
  methods: {
    getData: function getData(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                summaryExeDateData(_this.searchData).then(function (res) {
                  if (res.status == 200) {
                    _this.tableData = res.data ? [res.data] : [];
                  }
                }).finally(function () {
                  _this.isLoading = false;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDisable: function handleDisable(id) {
      var _this3 = this;

      disablePackagename({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          Message({
            message: res.message,
            type: "success"
          });

          _this3.getData(_this3.searchData.page);
        }
      });
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                summaryExeDateDel({
                  id: id
                }).then(function (res) {
                  _this4.getData(_this4.searchData.page);
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};